import { Dispatch, useEffect, useRef, useState } from "react";
import { Calendar } from "../util/Cal";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import moment from "moment";
import { getDifferenceInDays } from "./DateRange";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../store/actions";
import { addDays } from "date-fns";

const RangePicker = ({ dark = false }: { dark?: boolean } = {}) => {
  const date = useSelector((state: any) => state.form.date);
  const [dateOpen, setDateOpen] = useState(0);
  const dispatch: Dispatch<any> = useDispatch();

  const popoverRef: any = useRef(null);

  // Close popover when clicking outside
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        toggleDatePicker();
      }
    }

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverRef]);

  const toggleDatePicker = () => {
    let x = dateOpen;

    if (x === 1) {
      x = 0;
    } else {
      x = 1;
    }
    setDateOpen(x);
  };

  return (
    <div className="relative h-14 ">
      <div
        onClick={() => {
          toggleDatePicker();
        }}
        className={
          dark
            ? "border-white/25 bg-white/10 cursor-pointer h-full px-3 flex flex-col justify-start text-2xl font-extrabold outline-none border-[1px] rounded-[14px] w-auto focus-within:border-orange-400 transition-colors"
            : "border-[#302D6340] cursor-pointer h-full  px-2 flex flex-col justify-start text-2xl font-extrabold outline-none border-[1px] rounded-[4px] w-auto "
        }
      >
        <label className={dark ? "text-xs md:text-sm text-left font-normal text-white/80" : "text-xs md:text-sm  text-left font-normal text-[#17171780] "}>
          Select depature and return date
        </label>
        <div className="flex justify-between items-center h-8">
          {date.startDate && (
            <div className={dark ? "text-sm font-normal text-white" : "text-sm font-normal text-black"}>
              {moment.utc(date.startDate).format("ddd, MMM DD")}
            </div>
          )}
          {date.endDate && (
            <div className={dark ? "text-[10px] font-normal text-white/70" : "text-[10px] font-normal text-black"}>
              {getDifferenceInDays(
                new Date(date.startDate),
                new Date(date.endDate)
              )}{" "}
              days
            </div>
          )}
          <div className={dark ? "text-sm font-normal text-white" : "text-sm font-normal text-black"}>
            {date.endDate && moment.utc(date.endDate).format("ddd, MMM DD")}
          </div>
        </div>
      </div>
      {dateOpen === 1 && (
        <div
          ref={popoverRef}
          className={`absolute shadow-md right-0  bg-white p-4 flex flex-col items-start`}
        >
          <div className="text-[#000046] font-medium text-base">
            Select departure
          </div>

          <Calendar
            date={date.startDate ? new Date(date.startDate) : null}
            onChange={(d: any) => {
              const newDate = new Date(d);
              dispatch(
                Actions.setFlightDate({
                  startDate: moment(newDate).format("YYYY-MM-DD"),
                  endDate: null,
                  key: "selection",
                })
              );

              setDateOpen(2);
            }}
            minDate={new Date()}
            maxDate={new Date(2100, 0, 1)}
            dateDisplayFormat="d"
            monthDisplayFormat="MMM yyyy"
            weekStartsOn={1}
            //locale={enUS}
          />
        </div>
      )}{" "}
      {dateOpen === 2 && date?.startDate && (
        <div
          ref={popoverRef}
          className={`absolute shadow-md  left-0  bg-white p-4 flex flex-col items-end`}
        >
          <div className="flex justify-between w-full">
            <div className="flex flex-col">
              <span className="text-[.64rem]">Departure date</span>
              <span className="text-[#141414]">
                {moment.utc(new Date(date.startDate)).format("ddd, MMM DD")}
              </span>
            </div>
            <div className="text-[#000046] font-medium text-base">
              {" "}
              Select return
            </div>
          </div>

          <Calendar
            date={date ? new Date(date?.endDate) : null}
            onChange={(d: any) => {
              const newDate = new Date(d);

              // Use toISOString() to convert to ISO 8601 format in UTC
              const isoString = newDate.toISOString();
              console.log(d, isoString);
              dispatch(
                Actions.setFlightDate({
                  startDate: date?.startDate,
                  endDate: moment(newDate).format("YYYY-MM-DD"),
                  key: "selection",
                })
              );
              setDateOpen(0);
            }}
            minDate={new Date(date.startDate)}
            shownDate={new Date(date.startDate)}
            //  maxDate={new Date(2100, 0, 1)}
            dateDisplayFormat="d"
            monthDisplayFormat="MMM yyyy"
            weekStartsOn={1}
            locale={enUS}
          />

          <div
            className="cursor-pointer"
            onClick={() => {
              if (!date.endDate) {
                console.log(date);
                Actions.setFlightDate({
                  startDate: date.startDate,
                  endDate: addDays(date.startDate, 5),
                  key: "selection",
                });
              }
              setDateOpen(0);
            }}
          >
            done
          </div>
        </div>
      )}
    </div>
  );
};

export default RangePicker;
